import React from "react";
import Heading from "../Products/Heading";
import Product from "../Products/Product";
import {
  
  ac2,
  refrigerator1,
  geyser2,
  fan4,
} from "../../../assets/images/index";

const BestSellers = () => {
  return (
    <div className="w-full pb-20">
      <Heading heading="Our Bestsellers" />
      <div className="w-full grid grid-cols-1 md:grid-cols-2 lgl:grid-cols-3 xl:grid-cols-4 gap-10">
        <Product
          _id="1011"
          img={fan4}
          productName="Royal Passion Ceiling Fan - GRACE"
          price="10500"
          color="Royal"
          badge={false}
          offer4={true} 
          des="The Passion Ceiling fan is a customer favorite and a best seller. It has an elegant design with multiple decor and color options to suit your aesthetic need. It is perfect for your home or office. "
        />
        <Product
          _id="1012"
          img={ac2}
          productName="HAIER 1.5 TON TRIPLE INVERTER SPLIT AC Model HSU-18HFCS W"
          price="163800"
          color="HAIER"
          badge={false}
          offer5={true} 
          des="The Haier Triple Inverter HSU-18HFCS/013USDC (W) is a high-quality air conditioner that uses advanced triple inverter technology to reduce energy consumption and save you money on your electricity bills. This technology adjusts the compressor speed according to the temperature in the room, ensuring that the air conditioner only uses the amount of energy needed to cool the space."
        />
        <Product
          _id="1013"
          img={refrigerator1}
          productName="DAWLANCE TWO DOOR INVERTER REFRIGERATOR Model 91999 GRAZE+ GEM BLACK"
          price="149700"
          color="DAWLANCE"
          badge={false}
          offer6={true} 
          des="The Dawlance 91999 Graze+Gem Black Refrigerator combines sophistication and functionality. Its spacious storage and energy-efficient performance make it a must-have for contemporary households."
        />
        <Product
          _id="1014"
          img={geyser2}
          productName="CANON INSTANT GAS GEYSER Model IGWH-16DD"
          price="19800"
          color="CANON"
          badge={false}
          offer7={true} 
          des="The INS-16DD PLUS NG is an instant water geyser from Canon. It’s designed with a silver paint cover, grey bottom cover, and an ultra-low water-pressure start system. It also features flame out protection and battery auto ignition for safety and efficiency."
        />
      </div>
    </div>
  );
};

export default BestSellers;
